import angular from 'angular';
import moment from 'moment';

import templateUrl from './commission-policy-list.component.html'

export const CommissionPolicyListComponent = {
    templateUrl,
    controller: CommissionPolicyListController,
    controllerAs: "vm",
    bindings: {
        icdCorporationID: "<icdCorporationId"
    }
};

function CommissionPolicyListController($q, $window, commissionPolicyService,
    commissionPolicyArchiveService, divisionService, icdCorporationService, programService,
    retailerService, utilityService) {
    'ngInject'

    const vm = this;

    vm.$onInit = $onInit;
    vm.icdCorporation;
    vm.icdCorporationID;
    vm.pristineCommissionPolicies;
    vm.commissionPolicies;
    vm.programs;
    vm.retailers;
    // These are hydrated divisions and not just list models.
    vm.divisions;
    vm.today = moment().toDate();

    vm.loaded = false;
    vm.submitting = false;
    vm.showFilters = false;
    vm.filters = {};

    vm.filterDivisionPolicy = filterDivisionPolicy;
    vm.filterCommissionPolicy = filterCommissionPolicy;

    vm.onChangeIcdCorporation = onChangeIcdCorporation;
    vm.onCreateNewCommissionPolicy = onCreateNewCommissionPolicy;
    vm.onDeleteCommissionPolicy = onDeleteCommissionPolicy;
    vm.onValidateCommissionPolicy = onValidateCommissionPolicy;
    vm.onEditOtherCommissionPolicy = onEditOtherCommissionPolicy;
    vm.onSaveAll = onSaveAll;
    vm.onCancel = onCancel;
    vm.canEdit = false;
    vm.dropdownOptions = {
        dataSource: new kendo.data.DataSource({
            data: vm.icdCorporations,
        }),
        headerTemplate: `
                    <div style="padding: 8px 12px; border-bottom: 1px solid \\#ddd; cursor: pointer;">
                        <label class="control control-checkbox" style="margin: 0;">
                            <input type="checkbox" id="allcorps" name="allcorps" />
                            <span class="control-indicator"></span>
                            <span>Show Active</span>
                        </label>
                    </div>
                `,
        open: () => {
            setTimeout(() => {
                const widget = $("#IcdCorporation").data("kendoComboBox");
                const source = vm.icdCorporations;
                $("#allcorps").off("click").on("click", (e) => {
                    const isChecked = $(e.target).prop("checked");

                    const filtered = isChecked
                        ? source.filter(c => c.IcdCorporationStatus === 'Active')
                        : source;
                    widget.dataSource.data(filtered);
                    widget.refresh();
                    widget.popup.open(); // keep it open after refresh
                });
            }, 0);
        }
    }
    

    function $onInit() {

        $window.onbeforeunload = onBeforeUnload;

        $q.when(utilityService.showLoading())
            .then(loadInitialData)
            .then(function () {
                vm.loaded = true;
                vm.filters.activeOnly = true;
                vm.pristineCommissionPolicies = angular.copy(vm.commissionPolicies);
            })
            .catch(function (ex) {
                $.winxnetAlertWindow({ message: "Initial load failed: " + utilityService.getExceptionMessage(ex) });
            })
            .then(utilityService.hideLoading);

        
    }

    function loadInitialData() {
        const getIcdCorporations = icdCorporationService.retrieveIcdCorporationsByModuleAdmin("Commissions");
        const getSelectedIcdCorporation = getIcdCorporations.then(function (icdCorporations) {
            return icdCorporations.filter(function (icdCorporation) {
                return icdCorporation.Id === vm.icdCorporationID;
            })[0] || icdCorporations[0];
        });
        const getPrograms = programService.retrievePrograms();
        const getRetailers = retailerService.retrieveRetailers();
        const getCommissionPolicies = getSelectedIcdCorporation.then(function (icdCorporation) {
            if (!icdCorporation) {
                // No selection exists, so no results can be retrieved.
                return [];
            }
            return commissionPolicyService.retrieveCommissionPolicies(icdCorporation.Id)
        });
        const getDivisions = divisionService.retrieveDivisions()
            .then(function (divisions) {
                // The divisions listing doesn't include enough information, so load more from the details.
                return $q.all(divisions.map(function (division) {
                    return divisionService.retrieveDivision(division.Id);
                }));
            });
        const getCommissionPermissions = getSelectedIcdCorporation.then(function (icdCorporation) {
            if (!icdCorporation) {
                // No selection exists, so no results can be retrieved.
                return [];
            }
            return commissionPolicyService.retrieveCommissionPermissions(icdCorporation.Id);
        });
        //TODO: Also load the company schedule and payroll list so locked dates can be
        // determined and the program/retailer list can be filtered.
        // Load commissions for the selected company.

        return $q.all([getIcdCorporations, getSelectedIcdCorporation, getPrograms,
            getRetailers, getCommissionPolicies, getDivisions, getCommissionPermissions])
            .then(function (v) {
                // Load the data into the controller.
                vm.icdCorporations = v[0];
                vm.icdCorporations.map(corp => {
                    // Compile ICD and office name into single text field.
                    corp.ClientName = kendo.format("{0} - {1}", corp.Owner, corp.ClientName);
                    return corp;
                }).sort((a, b) => {
                    // Sort by the new text field.
                    return a.ClientName.toLowerCase() < b.ClientName.toLowerCase() ? -1 : 1;
                });
                vm.icdCorporation = v[1];
                vm.programs = v[2];
                vm.retailers = v[3];
                vm.canEdit = v[6];
                vm.pristineCommissionPolicies =
                    loadDivisionCommissionPolicies(v[4], vm.programs, vm.retailers, vm.canEdit);
                vm.commissionPolicies = angular.copy(vm.pristineCommissionPolicies);
                // No immediate dependencies on the divisions, but required in order to set defaults when adding new policies.
                vm.divisions = v[5];

            });
    }

    /**
     * Load the collection of commission policies, grouped by the division of the policy's program.
     * @param commissionPolicies The collection of commission policies
     * @param programs The collection of programs from which the policy should look up the program details by ID.
     * @param retailers The collection of retailers used to look up with retailer details by ID.
     */
    function loadDivisionCommissionPolicies(commissionPolicies, programs, retailers, canEdit) {
        // Group the policies by division.
        vm.canEdit = commissionPolicies.length ? commissionPolicies[0].CanModify : canEdit;

        const divisionPolicies = commissionPolicies.reduce(function (divisionPoliciesSet, policy) {
            // Look up and hydrate the policy's program and retailer.
            policy.Program = programs.filter(function (program) {
                return program.Id === policy.ProgramID;
            })[0];
            policy.Retailer = retailers.filter(function (retailer) {
                return retailer.Id === policy.RetailerID;
            })[0];
            policy.Locked = policy.Archives.reduce(function (locked, archive) {
                return locked || archive.Locked;
            }, false);
            policy.ActivePolicy = policy.Archives.reduce(function (last, archive) {
                return !last || last.ActiveStart < archive.ActiveStart ? archive : last;
            }, policy.Archives[0] || null);

            if (policy.Program) {
                let divisionPolicies = divisionPoliciesSet[policy.Program.DivisionID];
                if (divisionPolicies === undefined) {
                    divisionPolicies = {
                        DivisionID: policy.Program.DivisionID,
                        // No need to separately look up division for now.
                        DivisionName: policy.Program.DivisionName,
                        CommissionPolicies: []
                    };
                    divisionPoliciesSet[policy.Program.DivisionID] = divisionPolicies;
                }
                divisionPolicies.CommissionPolicies.push(policy);
            }

            return divisionPoliciesSet;
        }, {});

        return Object.values(divisionPolicies)
            .sort(function (a, b) {
                // Sort the list by division name.
                return a < b ? -1 : 1;
            });
    }

    function filterDivisionPolicy(divisionPolicy) {
        return divisionPolicy.CommissionPolicies.filter(filterCommissionPolicy).length > 0;
    }

    function filterCommissionPolicy(commissionPolicy) {

        return (!commissionPolicy.IsDeleted || !commissionPolicy.IsNew)
            && (!vm.filters.program || !commissionPolicy.Program
                || commissionPolicy.Program.Name.toLowerCase().indexOf(vm.filters.program.toLowerCase()) > -1)
            && (!vm.filters.retailer || !commissionPolicy.Retailer
                || commissionPolicy.Retailer.Name.toLowerCase().indexOf(vm.filters.retailer.toLowerCase()) > -1)
            && (!vm.filters.activeOnly || commissionPolicy.IsNew
                || commissionPolicy.editForm && commissionPolicy.editForm.$dirty
                || commissionPolicy.ActivePolicy && (!commissionPolicy.ActivePolicy.ActiveEnd
                    // If the active end date is in the future, it is also still active.
                    || commissionPolicy.ActivePolicy.ActiveEnd > vm.today));
    }

    function onValidateCommissionPolicy(commissionPolicy) {
        const commissionPolicies = vm.commissionPolicies.reduce(function (commissionPolicies, divisionPolicy) {
            commissionPolicies.push(...divisionPolicy.CommissionPolicies);
            return commissionPolicies;
        }, []);

        const anyDuplicates = commissionPolicyService.duplicateCommissionPolicyExists(
            commissionPolicy, commissionPolicies);
        commissionPolicy.editForm.$setValidity("unique", !anyDuplicates);
    }

    function onEditOtherCommissionPolicy(commissionPolicy) {
        if (!commissionPolicy.Program || !commissionPolicy.Retailer) {
            return;
        }
        // Find the commission policy that has the same program and store as the one passed in.
        const duplicate = vm.commissionPolicies.reduce(function (duplicate, divisionPolicy) {
            return duplicate || divisionPolicy.CommissionPolicies.reduce(function (duplicate, other) {
                return duplicate || other !== commissionPolicy && other.Program
                    && other.Program.Id === commissionPolicy.Program.Id
                    && other.Retailer && other.Retailer.Id === commissionPolicy.Retailer.Id && other;
            }, false);
        }, false);

        if (duplicate) {
            // Delete this commission policy and edit the duplicate instead.
            onDeleteCommissionPolicy(commissionPolicy);
            duplicate.isOpen = true;
        }

    }

    function onCreateNewCommissionPolicy(icdCorporation) {
        const newPolicy = {
            IsNew: true,
            IsDeleted: false,
            IcdCorporationID: icdCorporation.Id,
            ProgramID: null,
            RetailerID: null,
            Archives: [],
            isOpen: true
        };

        // Add a single new archive and tier to the policy by default.
        const newArchive = commissionPolicyArchiveService.addArchive(newPolicy);
        newArchive.isOpen = true;
        commissionPolicyArchiveService.addTier(newArchive);
        newArchive.ActivePolicy = newArchive;

        // Add or create a "New Policies" division and add the new policy to it.
        let newCommissionDivision = vm.commissionPolicies.filter(function (division) {
            return division.DivisionID === null;
        })[0];

        if (!newCommissionDivision) {
            newCommissionDivision = {
                DivisionID: null,
                DivisionName: "New Commission Policies",
                CommissionPolicies: []
            };
            vm.commissionPolicies.unshift(newCommissionDivision);
        }
        newCommissionDivision.CommissionPolicies.unshift(newPolicy);

        vm.editForm.$setDirty(true);
    }

    function onDeleteCommissionPolicy(commissionPolicy) {
        if (commissionPolicy.Locked) {
            throw "Cannot delete a commission policy because it contains locked archived tiers.";
        }

        if (commissionPolicy.IsDeleted || !commissionPolicy.IsNew && !confirm("The policy and all of its tiers will be deleted after you click Save.")) {
            // Clicking delete a second time toggles IsDeleted back off.
            commissionPolicy.IsDeleted = false;
            return;
        }

        vm.editForm.$setDirty(true);
        commissionPolicy.IsDeleted = true;
    }

    function onChangeIcdCorporation() {
        if (vm.editForm.$dirty && !confirm("Abandon your unsaved changes?")) {
            return;
        }

        vm.editForm.$setPristine(true);

        utilityService.showLoading();
        (function () {
            if (!vm.icdCorporation) {
                vm.commissionPolicies = [];
                return $q.when(vm.commissionPolicies);
            }
            const getCommissionPermissions =
                commissionPolicyService.retrieveCommissionPermissions(vm.icdCorporation.Id);
            const getCommissionPolicies = commissionPolicyService.retrieveCommissionPolicies(vm.icdCorporation.Id);
            return $q.all([getCommissionPermissions, getCommissionPolicies])
                .then(function (v) {
                    return loadDivisionCommissionPolicies(v[1], vm.programs, vm.retailers, v[0]);
                });
        })()
            .then(function (divisionCommissionPolicies) {
                vm.pristineCommissionPolicies = divisionCommissionPolicies;
                vm.commissionPolicies = angular.copy(vm.pristineCommissionPolicies);
            })
            .catch(angular.noop)
            .then(utilityService.hideLoading);
    }

    function onSaveAll() {
        if (!vm.editForm.$valid) {
            alert("Not valid.");
        }

        vm.submitting = true;
        utilityService.showLoading();
        const requests = vm.commissionPolicies.reduce(function (requests, divisionPolicies) {
            const saveRequests = divisionPolicies.CommissionPolicies.filter(function (policy) {
                return !policy.IsNew && policy.IsDeleted || policy.editForm && policy.editForm.$dirty;
            }).map(function (policy) {
                let saveRequest;
                if (policy.IsDeleted) {
                    saveRequest = commissionPolicyService.deleteCommissionPolicy(policy.Id);
                } else if (policy.IsNew) {
                    saveRequest = commissionPolicyService.createCommissionPolicy(policy);
                } else {
                    saveRequest = commissionPolicyService.updateCommissionPolicy(policy.Id, policy);
                }
                return saveRequest.catch(function (ex) {
                    if (ex.data && ex.data.ModelState) {
                        policy.errorModelState = ex.data.ModelState;
                    }
                    throw ex;
                });
            });
            requests.push(...saveRequests);
            return requests;
        }, []);

        $q.all(requests)
            .then(function () {
                if (!vm.icdCorporation) {
                    vm.commissionPolicies = [];
                    return $q.when(vm.commissionPolicies);
                }
                return commissionPolicyService.retrieveCommissionPolicies(vm.icdCorporation.Id);
            })
            .then(function (commissionPolicies) {
                return loadDivisionCommissionPolicies(commissionPolicies, vm.programs, vm.retailers, true);
            })
            .then(function (commissionPolicies) {
                vm.pristineCommissionPolicies = commissionPolicies;
                vm.commissionPolicies = angular.copy(vm.pristineCommissionPolicies);
                vm.editForm.$setPristine(true);
            })
            .catch(function (ex) {
                console.error(ex);
                $.winxnetAlertWindow({ message: "Saving failed: " + utilityService.getExceptionMessage(ex) });
            })
            .then(function () {
                vm.submitting = false;
                utilityService.hideLoading()
            });
    }

    function onCancel() {
        vm.commissionPolicies = angular.copy(vm.pristineCommissionPolicies);
        vm.editForm.$setPristine(true);
    }

    function onBeforeUnload() {
        if (vm.editForm && vm.editForm.$dirty) {
            return "You have unchanged changes that will be lost if you leave the page.";
        }
    }
}
